import * as Actions from '../actions';

const initialState = {
	success: false,
	// error: {
	// 	username: null,
	// 	password: null
	// },
	error: null,
	toasterActions: null,
};

const login = (state = initialState, action) => {
	switch (action.type) {
		case Actions.LOGIN_SUCCESS: {
			return {
				...state,
				success: true,
				error:null,
			};
		}
		case Actions.LOGIN_ERROR: {
			console.log('LOGIN ERROR -->', action.payload)
			return {
				...state,
				success: false,
				error: action.payload
			};
		}
		case Actions.LOGOUT_SUCCESS: {
			console.log("----------------------------------LOGOUT_SUCCESS----------------------------------",action)
			return {
				...initialState,
				error:null,
			};
		}
		/*case Actions.TOASTER_ACTION:{
			//debugger;
			//console.log('RECEBENDO NO REDUCERS', action.payload)
			return {
				...state,
				//toasterActions: action.payload,
			}
		}*/
		default: {
			return state;
		}
	}
	
};
//console.log('REDUCER ----->',Actions.TOASTER_ACTION)
export default login;
